export default __webpack_public_path__ + "static/media/10.a6897fd1.png";